var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewCalendar(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.875 3.438H4.125c-1.14 0-2.063.923-2.063 2.062v12.375c0 1.14.924 2.063 2.063 2.063h13.75c1.14 0 2.063-.924 2.063-2.063V5.5c0-1.14-.924-2.063-2.063-2.063z",
    stroke: "#2A848E",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.719 11a1.031 1.031 0 100-2.062 1.031 1.031 0 000 2.062zM16.156 11a1.031 1.031 0 100-2.063 1.031 1.031 0 000 2.063zM12.719 14.438a1.031 1.031 0 100-2.063 1.031 1.031 0 000 2.063zM16.156 14.438a1.031 1.031 0 100-2.063 1.031 1.031 0 000 2.063zM5.844 14.438a1.031 1.031 0 100-2.063 1.031 1.031 0 000 2.063zM9.281 14.438a1.031 1.031 0 100-2.063 1.031 1.031 0 000 2.063zM5.844 17.875a1.031 1.031 0 100-2.062 1.031 1.031 0 000 2.062zM9.281 17.875a1.031 1.031 0 100-2.062 1.031 1.031 0 000 2.062zM12.719 17.875a1.031 1.031 0 100-2.062 1.031 1.031 0 000 2.062z",
    fill: "#2A848E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 2.063v1.374m11-1.374v1.374",
    stroke: "#2A848E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.938 6.875H2.063",
    stroke: "#2A848E",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewCalendar);
export default ForwardRef;